module.exports = __webpack_public_path__ + "static/media/daisy.0f7809ed.svg";


//////////////////
// WEBPACK FOOTER
// ./src/daisy.svg
// module id = 78
// module chunks = 0